import React from 'react';
import classnames from 'classnames';
import { PapiComment } from '@wix/da-papi-types';
import TextRenderer from '../TextRenderer';
import SpamView from '../Comment/commonSkeletonViews/SpamView';
import CommentSkeleton from '../Comment/lego/CommentSkeleton';
import HiddenView from '../Comment/commonSkeletonViews/HiddenView';
import CommentCoreBadgeList from '../coreBadge/CoreBadgeList/presets/CommentCoreBadgeList';
import CommentTiptapViewer from '@wix/da-editor-tiptap/pkg/components/Viewer/presets/Comment';

import s from './CommentBody.scss';

export interface Props {
  comment: PapiComment;
  className?: string;
  bodyClassName?: string;
}

/** @deprecated */
const CommentBody: React.FC<React.PropsWithChildren<Props>> = ({
  comment,
  className,
  bodyClassName,
}) => {
  const { textContent, commentId } = comment;
  return (
    <CommentSkeleton
      className={className}
      comment={comment}
      editingView={null}
      spamView={<SpamView />}
      hiddenView={<HiddenView />}
      readView={
        <>
          {!!textContent && (
            <div className={s['comment-body-wrap']}>
              <TextRenderer
                textContent={textContent}
                className={classnames(s['comment'], bodyClassName)}
                legacyTheme={'comments'}
                viewerKey={commentId}
                tipTapViewer={CommentTiptapViewer}
                cookieType={undefined}
                defaultSize={{
                  desktop: { width: 580, height: 80 },
                  mobile: { width: 380, height: 80 },
                }}
              />
            </div>
          )}
          {comment.awardedBadges && <CommentCoreBadgeList comment={comment} />}
        </>
      }
    />
  );
};
CommentBody.displayName = 'CommentBody';

export default CommentBody;
